import type { Config } from "@jti/fe-common";

const getUrlHost = (url?: string): string => {
  if (!url) {
    return "";
  }

  try {
    return new URL(url).host;
  } catch {
    return "";
  }
};

export const createLegacyApiWarningAttributes = (
  config: Config,
  serviceUrl: string | undefined,
  configProvided = false
): Record<string, string | number> => ({
  configKeyCount: Object.keys(config).length,
  configProvided: Number(configProvided),
  hasEvoDomain: Number(Boolean(config.EVO_DOMAIN)),
  hasEvoTenant: Number(Boolean(config.EVO_TENANT)),
  hasServiceUrl: Number(Boolean(serviceUrl)),
  isoCountryCode: config.ISO_COUNTRY_CODE ?? "",
  serviceUrlHost: getUrlHost(serviceUrl),
  useEvoOnly: Number(Boolean(config.USE_EVO_ONLY)),
});
